/**
 * @desc 修改会员监管单位及商务经理
 */
import { MemberForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateMemberParameter = MemberForm

const method = 'PUT'
const url = '/auth/operation/member/update'

export const updateMemberApi = (
  data?: UpdateMemberParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

updateMemberApi.method = method
updateMemberApi.url = url
